import ErrorPage from "views/Error/Error";
import Home from "views/Home";
import Quiz from "../views/Quiz";
import SplashScreen from "../views/SectionSplashScreen";

export const routes = [
  {
    path: "/",
    element: <Home />,
    errorElement: <ErrorPage />
  },
];
